var _circle, _path, _path2, _g, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#EAF2FF",
    stroke: "url(#paint0_linear_623_66)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5996 31.5C40.5996 30.1193 41.7189 29 43.0996 29C44.4803 29 45.5996 30.1193 45.5996 31.5V36.5C45.5996 37.8807 44.4803 39 43.0996 39C41.7189 39 40.5996 37.8807 40.5996 36.5V31.5Z",
    fill: "#393184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4004 31.5C54.4004 30.1193 55.5197 29 56.9004 29C58.2811 29 59.4004 30.1193 59.4004 31.5V36.5C59.4004 37.8807 58.2811 39 56.9004 39C55.5197 39 54.4004 37.8807 54.4004 36.5V31.5Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_623_66)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 36,
    height: 36,
    fill: "url(#paint1_linear_623_66)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 36,
    height: 36,
    stroke: "url(#paint2_linear_623_66)",
    strokeWidth: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8108 48.563C42.9004 47.3854 43.3548 46.4638 44.174 45.7982C44.9932 45.1326 46.0556 44.7998 47.3612 44.7998C48.2316 44.7998 48.9804 44.9598 49.6076 45.2798C50.2476 45.587 50.7276 46.0094 51.0476 46.547C51.3804 47.0846 51.5468 47.6926 51.5468 48.371C51.5468 49.1646 51.3164 49.8494 50.8556 50.4254C50.4076 51.0014 49.8188 51.3726 49.0892 51.539V51.635C49.9212 51.8398 50.5804 52.243 51.0668 52.8446C51.5532 53.4462 51.7964 54.2334 51.7964 55.2062C51.7964 55.9358 51.63 56.595 51.2972 57.1838C50.9644 57.7598 50.4652 58.2142 49.7996 58.547C49.134 58.8798 48.334 59.0462 47.3996 59.0462C46.0428 59.0462 44.9292 58.6942 44.0588 57.9902C43.1884 57.2734 42.702 56.2622 42.5996 54.9566H44.2892C44.3788 55.7246 44.6924 56.3518 45.23 56.8382C45.7676 57.3246 46.4844 57.5678 47.3804 57.5678C48.2764 57.5678 48.9548 57.3374 49.4156 56.8766C49.8892 56.403 50.126 55.795 50.126 55.0526C50.126 54.0926 49.806 53.4014 49.166 52.979C48.526 52.5566 47.5596 52.3454 46.2668 52.3454H45.8252V50.8862H46.286C47.4636 50.8734 48.3532 50.6814 48.9548 50.3102C49.5564 49.9262 49.8572 49.3374 49.8572 48.5438C49.8572 47.8654 49.6332 47.3214 49.1852 46.9118C48.75 46.5022 48.1228 46.2974 47.3036 46.2974C46.51 46.2974 45.87 46.5022 45.3836 46.9118C44.8972 47.3214 44.6092 47.8718 44.5196 48.563H42.8108Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6947 46.6622V45.0686H57.3043V58.9502H55.5379V46.6622H53.6947Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_623_66",
    x: 29.85,
    y: 31.85,
    width: 40.3,
    height: 40.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_66",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BAD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_66",
    x1: 35.8524,
    y1: 37.3214,
    x2: 74.7096,
    y2: 57.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#393184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_66",
    x1: 53,
    y1: 40,
    x2: 66.5,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGlassIcon);
export default __webpack_public_path__ + "static/media/calendar-glass-icon.0368f5e66b1da4309ce974a69ae1f927.svg";
export { ForwardRef as ReactComponent };